import axios from 'axios';
import useAuthStore from '../store/authStore';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000/api',
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      useAuthStore.getState().clearUser();
    }
    return Promise.reject(error);
  }
);

// Get trending audios
export const getTrendingAudios = async () => {
  const response = await api.get('/home/audios/trending');
  return response.data;
};

// Get all trending series
export const getTrendingSeries = async () => {
  const response = await api.get('/series/trending/all');
  return response.data;
};

// Get trending series by category
export const getTrendingSeriesByCategory = async (categoryId) => {
  const response = await api.get(`/series/trending/${categoryId}`);
  return response.data;
};

export const getAudiosByCategory = async (categoryId, audioType) => {
  const response = await api.get(`/audios/category/${categoryId}/type/${audioType}`);
  return response.data;
};

// Get short audios by category
export const getShortAudiosByCategory = async (categoryId, page = 1, limit = 10) => {
  const response = await api.get(`/audios/short/${categoryId}`, {
    params: { page, limit }
  });
  return response.data;
};

export const getRecentlyAddedContent = async () => {
  const response = await api.get('/content/recently-added');
  return response.data;
};